/*
 * File:NewAppointmentFabButton.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 05/03/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles the new appointment FAB button and form
 */
import React, { useState } from "react";
import UIFormDialog from "components/ui/UIFormDialog";
import UIFab from "components/ui/UIFab";
import DateRangeIcon from "@material-ui/icons/DateRange";
import PropTypes from "prop-types";
import ApptForm from "services/appointments/components/ApptForm";
import { useNewApptModel } from "./useNewApptModel";

const NewAppointmentFabButton = ({ history }) => {
  const title = "New Appointment";
  const [showFormDialog, setShowFormDialog] = useState(false);
  const newApptModel = useNewApptModel();

  const formCallBack = newAppointmentId => {
    toggleFormDialog();
    let newURL = "/appointments/" + newAppointmentId;
    history.push(newURL);
  };

  const toggleFormDialog = () => {
    setShowFormDialog(!showFormDialog);
  };

  const apptForm = () => {
    return <ApptForm parentCallBack={formCallBack} appt={newApptModel} />;
  };

  return (
    <React.Fragment>
      <UIFab
        icon={<DateRangeIcon />}
        name={title}
        handleClick={toggleFormDialog}
      />
      <UIFormDialog
        open={showFormDialog}
        toggleDialog={toggleFormDialog}
        title={title}
        viewPage={apptForm}
      />
    </React.Fragment>
  );
};

NewAppointmentFabButton.propTypes = {
  history: PropTypes.object.isRequired
};

export default NewAppointmentFabButton;
